export type StringReplacementInstruction = {
  find: string;
  replacement: string;
};

export type ObjectToReplacementInstruction<T extends object> = (
  input: T,
) => StringReplacementInstruction;

export function transformSvg<T extends object>(
  svg: string,
  object: T,
  replacementInstructions: ObjectToReplacementInstruction<T>[],
): string {
  let transformedSvg = svg;

  replacementInstructions.forEach((replacementInstruction) => {
    const instruction = replacementInstruction(object);
    transformedSvg = transformedSvg.replace(
      instruction.find,
      instruction.replacement,
    );
  });

  return transformedSvg;
}
